import styled from 'styled-components';
import { tokens } from './tokens';
import { flexColumn } from './mixins';

export const OuterContentContainer = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  background: ${tokens.primitive.color.whiteAlpha60};
  min-height: 0;
`;

export const ContentContainer = styled.div`
  ${flexColumn}
  position: relative;
  flex: 1;
  min-height: 0;
  padding: ${tokens.primitive.space[40]};
`;

export const ContentBody = styled.div`
  background-color: ${tokens.primitive.color.whiteAlpha75};
  border-radius: ${tokens.primitive.radius[21]};
  flex: 1;
`;
